import React, { useState } from 'react';
import { Header } from '../../Typogaphy/Header';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';
import Chip from '@mui/material/Chip';
import MenuItem from '@mui/material/MenuItem';

import { FaUserCircle, FaPlusCircle, FaMinusCircle } from 'react-icons/fa';
import { pageRoutes } from '../../../routes/pageRoutes';

export const EducationalBackground = ({ handleStepper }) => {
  const [educBackground, setEducBackground] = useState([
    { level: false, university: '', degree: '', yearCompleted: '', undergrad: '', license: '' }
  ]);

  const levelType = [
    { value: true, label: 'Primary Level' },
    { value: false, label: 'Bachelors Level' }
  ];

  const handleAddEducBackground = () => {
    setEducBackground(prevItems => [
      ...prevItems,
      { level: false, university: '', degree: '', yearCompleted: '', undergrad: '', license: '' }
    ]);
  };

  const handleEducLevelChange = (index, value) => {
    setEducBackground(prevItems =>
      prevItems.map((item, i) =>
        i === index ? { ...item, level: value } : item
      )
    );
  };

  const handleChange = (index, label, value) => {
    setEducBackground(prevItems =>
      prevItems.map((item, i) =>
        i === index ? { ...item, [label]: value } : item
      )
    );
  };

  const removeItemByIndex = indexToRemove => {
    setEducBackground(prevItems =>
      prevItems.filter((_, index) => index !== indexToRemove)
    );
  };


  return (
    <div className='flex-1 overflow-y-auto p-4'>
      <div className='w-full items-center justify-between flex flex-row gap-2 my-3 max-sm:flex-col'>
        {/* <img
          className='w-[200px] h-[50px]'
          src={require('../../assets/logo2.png')}
          alt=''
        /> */}
        <div className='items-center flex flex-col my-3'>
          <Header text={'Educational Background'} style={'text-xl font-lexend'} />
          <span className='text-green-600 font-light font-lexend text-sm'>
            Applicant's Information
          </span>
        </div>
      </div>

      <div className='w-full flex flex-col gap-3 mb-5'>
        <div className='w-full flex flex-end justify-end'>
          <div
            onClick={handleAddEducBackground}
            className='font-lexend bg-green-600 flex flex-row items-center gap-2 justify-center rounded py-2 px-3 cursor-pointer text-white text-xs hover:bg-green-800'
          >
            <FaPlusCircle />
            <span>Add Educational Background</span>
          </div>
        </div>

        {educBackground.map((item, index) => (
          <React.Fragment key={index}>
            <Divider>
              <Chip
                label={`Educational Background ${index + 1}`}
                color='success'
                variant='outlined'

              />
            </Divider>

            <div className='w-full grid grid-cols-1 gap-2'>
              <div className='grid grid-cols-3 max-md:grid-cols-1 gap-2'>
                <FormControl fullWidth>
                  <span className='mb-3 font-normal text-xs font-lexend'>
                    Educational Level
                  </span>
                  <TextField
                    id={`educ-level-${index}`}
                    select
                    size='small'
                    label='Select here...'
                    value={item.level}
                    onChange={e => handleEducLevelChange(index, e.target.value)}
                  >
                    {levelType.map(option => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </FormControl>

                <FormControl fullWidth>
                  <span className='mb-3 font-normal text-xs font-lexend'>University</span>
                  <TextField
                    id={`university-${index}`}
                    size='small'
                    type='email'
                    onChange={e => handleChange(index, 'university', e.target.value)}
                    placeholder='type here...'
                  />
                </FormControl>

                {!item.level && (
                  <FormControl fullWidth>
                    <span className='mb-3 font-normal text-xs font-lexend'>Degree</span>
                    <TextField
                      id={`degree-${index}`}
                      size='small'
                      placeholder='Type here...'
                    />
                  </FormControl>
                )}
              </div>
              {!item.level && <div className='grid grid-cols-2 max-md:grid-cols-1 gap-2'>
                <FormControl fullWidth>
                  <span className='mb-3 font-normal text-xs  font-lexend'>
                    Year Completed
                  </span>
                  <TextField
                    id='outlined-required'
                    size='small'
                    type='email'
                    placeholder='type here...'
                  />
                </FormControl>

                <FormControl fullWidth>
                  <span className='mb-3 font-normal text-xs  font-lexend'>
                    Undergrad
                  </span>
                  <TextField
                    id='outlined-required'
                    size='small'
                    type='email'
                    placeholder='type here...'
                  />
                </FormControl>
              </div>}

              {!item.level && <FormControl fullWidth>
                <span className='mb-3 font-normal text-xs font-lexend'>
                  License
                </span>
                <TextField
                  id='outlined-required'
                  size='small'
                  type='email'
                  placeholder='type here...'
                />
              </FormControl>}

            </div>

            {educBackground.length > 1 && (
              <div className='w-full flex flex-start justify-start'>
                <div
                  onClick={() => removeItemByIndex(index)}
                  className='font-lexend bg-red-600 flex flex-row items-center gap-2 justify-center rounded py-2 px-3 cursor-pointer text-white text-xs hover:bg-red-800'
                >
                  <FaMinusCircle />
                  <span>Remove Educational Background</span>
                </div>
              </div>
            )}
          </React.Fragment>
        ))}

        <div className='w-full flex flex-end justify-end'>
          <div
            onClick={() => handleStepper(4)}
            className='font-lexend bg-green-600 flex flex-col items-center justify-center rounded py-2 px-3 cursor-pointer text-white font-medium hover:bg-green-800'
          >
            <span>Save Educational Background</span>
          </div>
        </div>
      </div>
    </div>
  );
};
